/**
 * Summary: Summary of the action
 * Description: Create api call
 * @author Pawan Gupta
 */

//Import
import { APIService } from "../service/api";
import { urlConstants } from "../constants/uri.constants";

//Public Method
/**
 * Description: handle getdata
 * @return {Promise}
 */
let previosCancelToken = '';
const getData = (dataToPost) => {
  if(typeof this.previosCancelToken != typeof undefined ){
    //console.log("token is present");
    this.previosCancelToken.cancel("Operation canceled due to new request.")
  }
  this.previosCancelToken = APIService.getCancelToken();
  //console.log("cancel token is ",this.previosCancelToken); 
  let url = "";
  let body = {};
  let header = {};
  url = urlConstants.BASEURL;
  var queryString = Object.keys(dataToPost).map(key => key + '=' + dataToPost[key]).join('&');
  let that = this;
  return APIService.post(url + "?" + queryString, header, {}, this.previosCancelToken).then(
    data => {
      let getResponse = data;
      if (getResponse) {
        return getResponse;
      } else {
        return null;
      }
    },
    error => {
      return { error: error };
    }
  );

};


//Public Method
/**
 * Description: handle get time 
 * @return {Promise}
 */
let previousGetTimeCancelToken = '';
const getCurrentTime = () => {
  if(typeof this.previousGetTimeCancelToken != typeof undefined ){
    //console.log("token is present");
    this.previousGetTimeCancelToken.cancel("Operation canceled due to new request.")
  }
  this.previousGetTimeCancelToken = APIService.getCancelToken();
  let url = "";
  let body = {};
  let header = {};
  url = urlConstants.GETCURRENTTIMEAPI;
  return APIService.get(url, header, {}, this.previousGetTimeCancelToken).then(
    data => {
      let getResponse = data;
      if (getResponse) {
        return getResponse;
      } else {
        return null;
      }
    },
    error => {
      return { error: error };
    }
  );

};


let previosPostCancelToken = '';
const postData = (dataToPost, headers) => {
  let url = "";
  let header = headers ? headers : {};

  if(typeof this.previosCancelToken != typeof undefined ){
    //console.log("token is present");
    this.previosCancelToken.cancel("Operation canceled due to new request.")
  }
  this.previosPostCancelToken = APIService.getCancelToken();
  
  url = urlConstants.HISTORYLOGAPI;

  //console.log("header --> ", header);
  return APIService.post(url, header,  dataToPost,  this.previosPostCancelToken).then(
    data => {
      let getResponse = data;
      if (getResponse) {
        return getResponse;
      } else {
        return null;
      }
    },
    error => {
      return { error: error };
    }
  );
};

//Export testActions
export const apiDataActions = {
  getData, postData, getCurrentTime
};



// WEBPACK FOOTER //
// ./src/actions/apidata.action.js